module.exports = __webpack_public_path__ + "img/硫化氢.50b1ae8a.png";